import { render, staticRenderFns } from "./BlockGalleryInput.vue?vue&type=template&id=140a4283&scoped=true&"
import script from "./BlockGalleryInput.vue?vue&type=script&lang=js&"
export * from "./BlockGalleryInput.vue?vue&type=script&lang=js&"
import style0 from "./BlockGalleryInput.vue?vue&type=style&index=0&id=140a4283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a4283",
  null
  
)

export default component.exports